import type { MemberDocument, DocumentCategory } from '@/data/seedMember'
import type { RawDocument, RawDocumentKind } from '@/types/api'

/**
 * Maps a raw document (`/me` documents) to the `MemberDocument` view-model.
 * Localizes the title from the document kind (falls back to the filename), and
 * folds the backend kind into the front-end category used by the tabs.
 * Takes a translator so the title follows the active locale.
 */

type Translate = (key: string, named?: Record<string, unknown>) => string

const KIND_TO_CATEGORY: Record<string, DocumentCategory> = {
  carte_identite: 'identite',
  passeport: 'identite',
  visa_titre_sejour: 'identite',
  carte_etudiante: 'etude',
  justificatif_domicile: 'justificatif',
  attestation_securite_sociale: 'justificatif',
  rib_remboursement: 'remboursement',
}

/** Kinds that have a localized label under `auth.account.documents.kinds`. */
const KNOWN_KINDS = new Set<RawDocumentKind>(Object.keys(KIND_TO_CATEGORY))

export function mapDocument(raw: RawDocument, t: Translate): MemberDocument {
  const kind = raw.kind ?? undefined
  const category: DocumentCategory = (kind && KIND_TO_CATEGORY[kind]) || 'justificatif'
  const title = kind && KNOWN_KINDS.has(kind)
    ? t(`auth.account.documents.kinds.${kind}`)
    : raw.filename
  return {
    title,
    fileName: raw.filename,
    category,
    addedAt: raw.received_on ?? raw.created_at,
    url: raw.url,
    downloadUrl: raw.download_url,
  }
}
